import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  CurrentMarker,
  DateRangeWrapper,
  EndDateText,
  NotStartedText,
  NotStartedWrapper,
  OverallBar,
  ProgressBar,
  ProgressBarWrapper,
  StartDateText,
  StyledTooltip,
  TooltipContainer,
  Wrapper,
} from './component.styles'
import { pluralizeEnglish } from '../../utils/stringHelpers'

const DateRange = ({
  className,
  endDateInMs,
  endDateTextFormatted,
  progressBarView,
  startDateInMs,
  startDateTextFormatted,
}) => {
  const [isHovered, setIsHovered] = useState(false)
  const todaysDate = new Date().getTime()

  const isTodayBeforeStartDate = todaysDate < startDateInMs
  const isTodayAfterEndDate = todaysDate > endDateInMs
  const isInRange = !isTodayBeforeStartDate && !isTodayAfterEndDate

  const calculateProgressBarWidth = () => {
    if (isTodayBeforeStartDate) {
      return 0.0
    }
    if (isTodayAfterEndDate) {
      return 100.0
    }
    return Math.floor(
      ((todaysDate - startDateInMs) / (endDateInMs - startDateInMs)) * 100.0,
    )
  }
  const progressBarWidth = calculateProgressBarWidth()

  const notStartedText = `${startDateTextFormatted}–${endDateTextFormatted}`

  const handlePointerEnter = () => {
    setIsHovered(true)
  }

  const handlePointerLeave = () => {
    setIsHovered(false)
  }

  const handleOnClick = () => {
    setIsHovered(!isHovered)
  }

  const calculateDaysLeft = () => {
    if (isTodayBeforeStartDate) {
      return Math.ceil((endDateInMs - startDateInMs) / (1000 * 60 * 60 * 24))
    }
    if (isTodayAfterEndDate) {
      return 0
    }
    return Math.ceil((endDateInMs - todaysDate) / (1000 * 60 * 60 * 24))
  }
  const tooltipContent = () => {
    const daysLeft = calculateDaysLeft()
    const tooltipMessage = `${pluralizeEnglish(
      daysLeft,
      'day',
      'days',
    )} remaining`
    return <span>{tooltipMessage}</span>
  }

  return (
    <Wrapper
      className={className}
      onClick={handleOnClick}
      onPointerEnter={handlePointerEnter}
      onPointerLeave={handlePointerLeave}
    >
      {(isInRange || progressBarView) && (
        <DateRangeWrapper>
          <StartDateText>{startDateTextFormatted}</StartDateText>
          <ProgressBarWrapper>
            <OverallBar />
            <ProgressBar progressBarWidth={progressBarWidth} />
            <CurrentMarker markerPosition={progressBarWidth} />
            {tooltipContent && (
              <StyledTooltip
                content={tooltipContent()}
                isSiblingHovered={isHovered}
                tooltipContentPosition={progressBarWidth}
              >
                <TooltipContainer />
              </StyledTooltip>
            )}
          </ProgressBarWrapper>
          <EndDateText>{endDateTextFormatted}</EndDateText>
        </DateRangeWrapper>
      )}
      {!isInRange && !progressBarView && (
        <NotStartedWrapper>
          <NotStartedText>{notStartedText}</NotStartedText>
        </NotStartedWrapper>
      )}
    </Wrapper>
  )
}

DateRange.propTypes = {
  className: PropTypes.string,
  endDateInMs: PropTypes.number,
  endDateTextFormatted: PropTypes.string,
  progressBarView: PropTypes.bool,
  startDateInMs: PropTypes.number,
  startDateTextFormatted: PropTypes.string,
}

export default DateRange
